/** Muestra `...` + últimos caracteres; el id completo debe ir en `title` del contenedor. */
export function truncateDisplayId(id: string, suffixLength = 6): string {
  if (!id) return ''
  if (id.length <= suffixLength + 3) return id
  return `...${id.slice(-suffixLength)}`
}
